var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bank-line (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zeplin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Funds---New-Deposit-Praxis---Desktop---Selection",
    transform: "translate(-332.000000, -436.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(292.000000, 436.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bank-line-(1)",
    transform: "translate(40.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66666667,26.6666667 L29.3333333,26.6666667 L29.3333333,29.3333333 L2.66666667,29.3333333 L2.66666667,26.6666667 Z M5.33333333,16 L8,16 L8,25.3333333 L5.33333333,25.3333333 L5.33333333,16 Z M12,16 L14.6666667,16 L14.6666667,25.3333333 L12,25.3333333 L12,16 Z M17.3333333,16 L20,16 L20,25.3333333 L17.3333333,25.3333333 L17.3333333,16 Z M24,16 L26.6666667,16 L26.6666667,25.3333333 L24,25.3333333 L24,16 Z M2.66666667,9.33333333 L16,2.66666667 L29.3333333,9.33333333 L29.3333333,14.6666667 L2.66666667,14.6666667 L2.66666667,9.33333333 Z M5.33333333,10.9813333 L5.33333333,12 L26.6666667,12 L26.6666667,10.9813333 L16,5.648 L5.33333333,10.9813333 Z M16,10.6666667 C15.2636203,10.6666667 14.6666667,10.069713 14.6666667,9.33333333 C14.6666667,8.59695367 15.2636203,8 16,8 C16.7363797,8 17.3333333,8.59695367 17.3333333,9.33333333 C17.3333333,10.069713 16.7363797,10.6666667 16,10.6666667 Z",
    id: "Shape",
    fill: "#138518",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.aae6b66e.svg";
export { ForwardRef as ReactComponent };